import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  provideClientHydration,
  withEventReplay,
  withNoHttpTransferCache,
  withNoIncrementalHydration,
} from '@angular/platform-browser';
import { ImagePipe } from './pipes/image.pipe';
import { BackgroundImagePipe } from './pipes/background-image.pipe';
import { provideSignalVault } from '@mackao/signalvault-angular';
import {
  provideDetailedGlobalErrorLogging,
  signalVaultConfig,
} from './services/signal-vault-log';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideDetailedGlobalErrorLogging(),
    provideSignalVault({
      ...signalVaultConfig,
      enabled: typeof window !== 'undefined',
    }),
    provideAnimationsAsync(),
    provideClientHydration(
      withEventReplay(),
      withNoHttpTransferCache(),
      withNoIncrementalHydration(),
    ),
    ImagePipe,
    BackgroundImagePipe,
  ],
};
